import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions';
import heap from '../modules/heap';

import CreateAccount from '../containers/CreateAccount/CreateAccount';
import CreateAccountHeader from '../containers/CreateAccountHeader/CreateAccountHeader.jsx';
import Footer from '../components/Footer/Footer';
import GetTheApp from '../containers//GetTheApp/GetTheApp';
import Logo from '../components/Logo/Logo';
import Login from '../containers/Login/Login.jsx';
import Modal from '../components/Modal/Modal';
import PolicyDetails from '../containers/PolicyDetails/PolicyDetails';
import SetUpBilling from '../containers/SetUpBilling/SetUpBilling';
import SignYourForms from '../containers/SignYourForms/SignYourForms';
import StickyHeader from '../components/StickyHeader/StickyHeader';
import WatchYourMail from '../containers/WatchYourMail/WatchYourMail';
import Welcome from '../containers/Welcome/Welcome';
import WhoWeAre from '../containers/WhoWeAre/WhoWeAre';
import YourInformation from '../containers/YourInformation/YourInformation';
import IntroTemplate from '../templates/Intro';

export class Default extends Component {
    constructor() {
        super();
        this.state = {
            showModal: false
        };
    }

    componentDidMount() {
        setTimeout(
            c => {
                if (!c.props.customer.isAuthenticated) {
                    heap.track('customerPortal', { isAuthenticated: false });
                }
            },
            3000,
            this
        );
    }

    requestCustomerDetails() {
        this.props.requestCustomerDetails(
            {
                lastName: this.props.customer.lastName,
                accessCode: this.props.customer.accessCode
            },
            {
                accessToken: this.props.customer.apigee.access_token,
                jwtToken: this.props.customer.apigee.jwtToken,
                env: this.props.app.deploy.env
            }
        );
    }

    componentDidUpdate() {
        if (
            this.props.customer.isValid &&
            this.props.customer.isAuthenticated &&
            !this.props.details.customerData &&
            !this.props.details.isLoading &&
            !this.props.details.hasError
        ) {
            this.requestCustomerDetails();
        }

        if (this.props.customer.isValid && this.props.customer.isAuthenticated) {
            try {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            } catch (err) {
                console.log('unable to scroll window');
            }
        }

        if (this.props.customer.isAuthenticated) {
            heap.track('customerPortal', { isAuthenticated: true });
        }
    }

    render() {
        return (
            <IntroTemplate
                hasError={this.props.details.hasError}
                header={
                    <StickyHeader>
                        <Logo />
                        {this.props.customer.isAuthenticated ? <CreateAccountHeader /> : <Login />}
                        <Modal
                            isShown={
                                this.props.customer.isValid &&
                                !this.props.customer.isAuthenticated &&
                                !this.props.customer.hasError
                            }
                            canBeClosed
                            type="security"
                        />
                    </StickyHeader>
                }
                footer={<Footer />}>
                <YourInformation />
                <PolicyDetails />
                <Welcome />
                <WhoWeAre />
                <WatchYourMail />
                <SignYourForms>
                    Make sure you work with your agent to cancel your old policy – this will prevent
                    you from getting billed twice.
                </SignYourForms>
                <SetUpBilling />
                <CreateAccount deploy={this.props.app.deploy} />
                <GetTheApp />
            </IntroTemplate>
        );
    }
}

function mapStoreToProps(store) {
    return {
        customer: store.customer,
        details: store.details,
        app: store.app
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        requestCustomerDetails: (data, tokens) =>
            dispatch(actions.details.requestCustomerDetails({ tokens, data }))
    };
}

export default connect(
    mapStoreToProps,
    mapDispatchToProps
)(Default);



// WEBPACK FOOTER //
// ./src/pages/Default.jsx